

(function ($) {
  const NAMESPACE = 'check-all';

  $.fn.checkAll = function () {
    return this.each(function () {
      const $this = $(this);


      const $masterCheckbox = $this.find(`[data-${NAMESPACE}=master]`);


      const $slaveCheckboxes = $this.find(`[data-${NAMESPACE}=slave]`);


      const $count = $this.find(`[data-${NAMESPACE}=count]`);


      let checked = 0;

      init();

      function hasBulkButton() {
        const bulkButton = $this.find(`[data-${NAMESPACE}=count]`);
        return bulkButton.length > 0;
      }

      function hasCount() {
        return $count.length > 0;
      }

      function init() {
        updateAll();
        bindEvents();
      }

      function bindEvents() {
        $masterCheckbox.on('change.checkAll', () => {
          updateAll();
        });

        $slaveCheckboxes.on('change.checkAll', function () {
          updateCheckbox(this);
        });
      }

      function updateCount(isChecked) {
        if (checked === 0) {
          $count.hide();
        } else {
          $count.show();
        }

        $count.html(checked);
      }

      function count(isChecked) {
        if (isChecked) {
          ++checked;
        } else if (checked > 0) {
          --checked;
        }
      }

      function updateButton() {
        const $button = $this.find(`[data-${NAMESPACE}=button]`);


        let disabled;

        if (checked === 0) {
          disabled = true;
        } else {
          disabled = false;
        }

        $button.prop('disabled', disabled);
      }

      function updateAll() {
        const $enabledCheckboxes = $slaveCheckboxes.not(':disabled');


        const isChecked = $masterCheckbox.is(':checked');

        $enabledCheckboxes.prop('checked', isChecked);

        if (hasCount()) {
          checked = $enabledCheckboxes.filter(':checked').length;
          updateCount(isChecked);
        }

        if (hasBulkButton()) {
          updateButton();
        }
      }

      function updateCheckbox(checkbox) {
        const isChecked = checkbox.checked;

        if (hasCount()) {
          count(isChecked);
          updateCount(isChecked);
        }

        if (hasBulkButton()) {
          updateButton();
        }

        updateMaster();
      }

      function updateMaster() {
        if ($slaveCheckboxes.filter(':checked').length === 0) {
          $masterCheckbox.prop('checked', false);
        } else if (!$masterCheckbox.is(':checked')) {
          $masterCheckbox.prop('checked', true);
        }
      }
    });
  };

  $(() => {
    $(`[data-plugin=${NAMESPACE}]`).checkAll();
  });
}(jQuery));
